module.exports = __webpack_public_path__ + "img/madnessBanner_1920.be68f288.png";